// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__27Xhw","label":"SetPasswdForm_label__3jfVu"};